module.exports = __webpack_public_path__ + "media/images/back-header-c7c2a1c2f0f9174b0457ab8026caea60.jpg";